import styled from "styled-components";

const IconContainer = styled("div")`
    position: relative;
    color: ${props => props.theme.colors.main};
    display: flex;
    justify-content: center;
    align-items: center;
`

export default IconContainer;